// Categorias do breakdown de armazenamento (chaves vêm do backend —
// computeStorageUsage em obra-tycoon-backend/index.js). Compartilhado entre
// a aba Armazenamento do /admin da obra e a aba Dados do /administrador.
export interface StorageCategory {
  key: string
  label: string
  color: string
}

export const STORAGE_CATEGORIES: StorageCategory[] = [
  { key: 'arquivosMb', label: 'Arquivos de projeto', color: '#0f4c81' },
  { key: 'manuaisMb', label: 'Manuais (PDF)', color: '#7c3aed' },
  { key: 'relatoriosMb', label: 'Relatórios (texto + fotos)', color: '#16a34a' },
  { key: 'fotosMb', label: 'Fotos (progresso, DDS, presenças...)', color: '#0891b2' },
  { key: 'almoxarifadoMb', label: 'Almoxarifado', color: '#d97706' },
  { key: 'ticketsMb', label: 'Chamados (fotos + anexos)', color: '#dc2626' },
  { key: 'avataresMb', label: 'Avatares', color: '#f59e0b' }
]

export function breakdownToItems(breakdown?: Record<string, number> | null) {
  if (!breakdown) return []
  return STORAGE_CATEGORIES
    .filter(c => typeof breakdown[c.key] === 'number')
    .map(c => ({ ...c, mb: breakdown[c.key] }))
}
